import React, { useState } from "react";

import { UserLoggedInNavigatorScreenProps } from "../../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { WATaskSingleSettings } from "./WATaskSingleSettings/WATaskSingleSettings";
import { WATaskSingleSizePreview } from "./WATaskSingleSizePreview";

import { WATaskSingleContext } from "./WATaskSingleContext";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { WidgetScreen } from "../../../common/WidgetScreen";

type Props = UserLoggedInNavigatorScreenProps<"WidgetAddTaskSingle">;

export const WATaskSingle = withWebModal(WATaskSingleC, true);
function WATaskSingleC(props: Props) {
  const [sectionIds, setSectionIds] = useState<string[]>([]);
  const [taskId, setTaskId] = useState<string | null>(null);

  return (
    <WATaskSingleContext.Provider
      value={{
        taskId,
        sectionIds,
        setSectionIds,
        setTaskId,
        storecastId: props.route.params.storecastId,
      }}
    >
      <WidgetScreen
        preview={
          <WATaskSingleSizePreview
            maxSize={props.route.params.maxSize}
            position={props.route.params.position}
            storecastId={props.route.params.storecastId}
            taskId={taskId}
            unitSize={props.route.params.unitSize}
          />
        }
        settings={<WATaskSingleSettings />}
      />
    </WATaskSingleContext.Provider>
  );
}
